import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/notification-manuals', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/notification-manuals', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store
}
